import { getMessages } from '../../../../../../../store/constants';

export const CARD_ASSIGNEE_ADD = getMessages().getText('card_form_assignee_add');
